import React from 'react'

export const PrivacyTermsConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                },
                leftSidePanel: {
                    display: false
                },
                rightSidePanel: {
                    display: false
                }
            }
        }
    },
    routes: [
        {
            path: '/terms',
            component: React.lazy(() => import('./Terms')),
            applicationPath: 'Terms',
        },
        {
            path: '/privacyPolicy',
            component: React.lazy(() => import('./PrivacyPolicy')),
            applicationPath: 'PrivacyPolicy',
        },
    ]
}